export type AuthMode = "login" | "register" | "verify" | "forgot" | "reset";

export function authPresentation(mode: AuthMode, maintenanceEnabled: boolean, email: string) {
  if (maintenanceEnabled && mode === "login") {
    return {
      title: "网站维护中",
      description: "普通用户暂时无法访问，管理员账号可继续登录。",
      submitLabel: "管理员登录",
    };
  }
  return {
    title: {
      login: "登录",
      register: "创建账户",
      verify: "验证邮箱",
      forgot: "找回密码",
      reset: "设置新密码",
    }[mode],
    description: mode === "login"
      ? ""
      : mode === "register"
        ? "验证码将发送至此邮箱。"
        : mode === "verify"
          ? email ? `验证码已发送至 ${email}` : "输入邮件中的验证码。"
          : mode === "forgot"
            ? "验证码将发送至注册邮箱。"
            : "输入邮件验证码并设置新密码。",
    submitLabel: mode === "login"
      ? "登录"
      : mode === "register"
        ? "发送验证码"
        : mode === "forgot"
          ? "发送验证码"
          : mode === "verify"
            ? "验证邮箱"
            : "更新密码",
  };
}
